// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* Box sizing reset */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border-width: 0; /* Explicitly reset border width */
    border-style: solid; /* Ensure consistent border style */
    border-color: inherit;
  }

  /* Basic document-level defaults */
  html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    font-family: inherit;
  }

  body {
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
    /* border: inherit; */
    border-color: inherit;
    background-color: inherit;
  }

  /* Remove list styles */
  ul,
  ol {
    list-style: none;
  }

  /* Anchor tag reset */
  a {
    text-decoration: inherit;
    color: inherit;
  }

  /* Only lighten existing div borders */
  div,
  input,
  textarea {
    border-color: inherit; /* Prevent forcing borders on all divs */
  }

  /* Lighten borders for divs that already have borders */
  textarea,
  input,
  div[style*='border'] textarea,
  input,
  div[class*='border'] {
    border-color: #ddd !important; /* Lighten existing borders */
  }
*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
}
.\\!container {
    width: 100% !important;
}
.container {
    width: 100%;
}
@media (min-width: 640px) {
    .\\!container {
        max-width: 640px !important;
    }
    .container {
        max-width: 640px;
    }
}
@media (min-width: 768px) {
    .\\!container {
        max-width: 768px !important;
    }
    .container {
        max-width: 768px;
    }
}
@media (min-width: 900px) {
    .\\!container {
        max-width: 900px !important;
    }
    .container {
        max-width: 900px;
    }
}
@media (min-width: 1024px) {
    .\\!container {
        max-width: 1024px !important;
    }
    .container {
        max-width: 1024px;
    }
}
@media (min-width: 1280px) {
    .\\!container {
        max-width: 1280px !important;
    }
    .container {
        max-width: 1280px;
    }
}
@media (min-width: 1536px) {
    .\\!container {
        max-width: 1536px !important;
    }
    .container {
        max-width: 1536px;
    }
}
.visible {
    visibility: visible;
}
.fixed {
    position: fixed;
}
.absolute {
    position: absolute;
}
.relative {
    position: relative;
}
.sticky {
    position: sticky;
}
.inset-0 {
    inset: 0px;
}
.inset-x-0 {
    left: 0px;
    right: 0px;
}
.inset-y-0 {
    top: 0px;
    bottom: 0px;
}
.-top-2 {
    top: -0.5rem;
}
.-top-4 {
    top: -1rem;
}
.bottom-0 {
    bottom: 0px;
}
.bottom-16 {
    bottom: 4rem;
}
.bottom-2 {
    bottom: 0.5rem;
}
.bottom-4 {
    bottom: 1rem;
}
.bottom-full {
    bottom: 100%;
}
.left-0 {
    left: 0px;
}
.left-1\\/2 {
    left: 50%;
}
.left-3 {
    left: 0.75rem;
}
.left-4 {
    left: 1rem;
}
.left-full {
    left: 100%;
}
.right-0 {
    right: 0px;
}
.right-2 {
    right: 0.5rem;
}
.right-4 {
    right: 1rem;
}
.right-auto {
    right: auto;
}
.right-full {
    right: 100%;
}
.top-0 {
    top: 0px;
}
.top-1\\/2 {
    top: 50%;
}
.top-1\\/3 {
    top: 33.333333%;
}
.top-10 {
    top: 2.5rem;
}
.top-2 {
    top: 0.5rem;
}
.top-64 {
    top: 16rem;
}
.top-full {
    top: 100%;
}
.z-100000 {
    z-index: 100000;
}
.z-100001 {
    z-index: 100001;
}
.z-100002 {
    z-index: 100002;
}
.z-100050 {
    z-index: 100050;
}
.z-100051 {
    z-index: 100051;
}
.z-40 {
    z-index: 40;
}
.z-50 {
    z-index: 50;
}
.col-span-1 {
    grid-column: span 1 / span 1;
}
.m-1 {
    margin: 0.25rem;
}
.m-2 {
    margin: 0.5rem;
}
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
}
.my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.-mt-3 {
    margin-top: -0.75rem;
}
.-mt-px {
    margin-top: -1px;
}
.mb-1 {
    margin-bottom: 0.25rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.mb-4 {
    margin-bottom: 1rem;
}
.mb-6 {
    margin-bottom: 1.5rem;
}
.ml-0 {
    margin-left: 0px;
}
.ml-1 {
    margin-left: 0.25rem;
}
.ml-2 {
    margin-left: 0.5rem;
}
.ml-8 {
    margin-left: 2rem;
}
.ml-auto {
    margin-left: auto;
}
.mr-1 {
    margin-right: 0.25rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mt-1 {
    margin-top: 0.25rem;
}
.mt-2 {
    margin-top: 0.5rem;
}
.mt-3 {
    margin-top: 0.75rem;
}
.mt-4 {
    margin-top: 1rem;
}
.mt-5 {
    margin-top: 1.25rem;
}
.mt-6 {
    margin-top: 1.5rem;
}
.line-clamp-5 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
}
.block {
    display: block;
}
.inline-block {
    display: inline-block;
}
.flex {
    display: flex;
}
.inline-flex {
    display: inline-flex;
}
.grid {
    display: grid;
}
.hidden {
    display: none;
}
.size-10 {
    width: 2.5rem;
    height: 2.5rem;
}
.size-28 {
    width: 7rem;
    height: 7rem;
}
.size-4 {
    width: 1rem;
    height: 1rem;
}
.size-5 {
    width: 1.25rem;
    height: 1.25rem;
}
.size-6 {
    width: 1.5rem;
    height: 1.5rem;
}
.size-8 {
    width: 2rem;
    height: 2rem;
}
.\\!h-4 {
    height: 1rem !important;
}
.\\!h-full {
    height: 100% !important;
}
.h-0 {
    height: 0px;
}
.h-0\\.5 {
    height: 0.125rem;
}
.h-1 {
    height: 0.25rem;
}
.h-12 {
    height: 3rem;
}
.h-16 {
    height: 4rem;
}
.h-2 {
    height: 0.5rem;
}
.h-20 {
    height: 5rem;
}
.h-24 {
    height: 6rem;
}
.h-3 {
    height: 0.75rem;
}
.h-32 {
    height: 8rem;
}
.h-4 {
    height: 1rem;
}
.h-5 {
    height: 1.25rem;
}
.h-52 {
    height: 13rem;
}
.h-6 {
    height: 1.5rem;
}
.h-64 {
    height: 16rem;
}
.h-7 {
    height: 1.75rem;
}
.h-8 {
    height: 2rem;
}
.h-96 {
    height: 24rem;
}
.h-\\[30px\\] {
    height: 30px;
}
.h-auto {
    height: auto;
}
.h-dvh {
    height: 100dvh;
}
.h-fit {
    height: -moz-fit-content;
    height: fit-content;
}
.h-full {
    height: 100%;
}
.\\!max-h-8 {
    max-height: 2rem !important;
}
.max-h-60 {
    max-height: 15rem;
}
.max-h-72 {
    max-height: 18rem;
}
.min-h-\\[200px\\] {
    min-height: 200px;
}
.min-h-\\[300px\\] {
    min-height: 300px;
}
.min-h-screen {
    min-height: 100vh;
}
.\\!w-12 {
    width: 3rem !important;
}
.\\!w-4 {
    width: 1rem !important;
}
.\\!w-full {
    width: 100% !important;
}
.w-0 {
    width: 0px;
}
.w-0\\.5 {
    width: 0.125rem;
}
.w-1 {
    width: 0.25rem;
}
.w-1\\/2 {
    width: 50%;
}
.w-1\\/3 {
    width: 33.333333%;
}
.w-1\\/4 {
    width: 25%;
}
.w-10 {
    width: 2.5rem;
}
.w-10\\/12 {
    width: 83.333333%;
}
.w-12 {
    width: 3rem;
}
.w-16 {
    width: 4rem;
}
.w-2 {
    width: 0.5rem;
}
.w-2\\/3 {
    width: 66.666667%;
}
.w-2\\/5 {
    width: 40%;
}
.w-20 {
    width: 5rem;
}
.w-24 {
    width: 6rem;
}
.w-3 {
    width: 0.75rem;
}
.w-3\\/4 {
    width: 75%;
}
.w-3\\/5 {
    width: 60%;
}
.w-32 {
    width: 8rem;
}
.w-4 {
    width: 1rem;
}
.w-4\\/5 {
    width: 80%;
}
.w-48 {
    width: 12rem;
}
.w-5 {
    width: 1.25rem;
}
.w-6 {
    width: 1.5rem;
}
.w-64 {
    width: 16rem;
}
.w-8 {
    width: 2rem;
}
.w-80 {
    width: 20rem;
}
.w-96 {
    width: 24rem;
}
.w-\\[30px\\] {
    width: 30px;
}
.w-auto {
    width: auto;
}
.w-fit {
    width: -moz-fit-content;
    width: fit-content;
}
.w-full {
    width: 100%;
}
.min-w-10 {
    min-width: 2.5rem;
}
.min-w-14 {
    min-width: 3.5rem;
}
.min-w-\\[80px\\] {
    min-width: 80px;
}
.max-w-2xl {
    max-width: 42rem;
}
.max-w-4xl {
    max-width: 56rem;
}
.max-w-7xl {
    max-width: 80rem;
}
.max-w-\\[200px\\] {
    max-width: 200px;
}
.max-w-fit {
    max-width: -moz-fit-content;
    max-width: fit-content;
}
.max-w-full {
    max-width: 100%;
}
.max-w-lg {
    max-width: 32rem;
}
.max-w-none {
    max-width: none;
}
.max-w-sm {
    max-width: 24rem;
}
.max-w-xs {
    max-width: 20rem;
}
.flex-1 {
    flex: 1 1 0%;
}
.flex-shrink-0 {
    flex-shrink: 0;
}
.flex-grow {
    flex-grow: 1;
}
.border-collapse {
    border-collapse: collapse;
}
.-translate-x-1 {
    --tw-translate-x: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2 {
    --tw-translate-y: -0.5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\.5 {
    --tw-translate-y: -0.625rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
    --tw-translate-y: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
    --tw-translate-y: 50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
    --tw-rotate: 45deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
    --tw-scale-x: .75;
    --tw-scale-y: .75;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
    --tw-scale-x: .9;
    --tw-scale-y: .9;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes slideInBottom {
    0% {
        transform: translateY(-100%);
    }
    100% {
        transform: translateY(0);
    }
}
.animate-slide-in-bottom {
    animation: slideInBottom 0.3s ease-out;
}
@keyframes slideInLeft {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
}
.animate-slide-in-left {
    animation: slideInLeft 0.3s ease-out;
}
@keyframes slideInRight {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0);
    }
}
.animate-slide-in-right {
    animation: slideInRight 0.3s ease-out;
}
@keyframes slideInTop {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}
.animate-slide-in-top {
    animation: slideInTop 0.3s ease-out;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite;
}
.cursor-default {
    cursor: default;
}
.cursor-grab {
    cursor: grab;
}
.cursor-not-allowed {
    cursor: not-allowed;
}
.cursor-pointer {
    cursor: pointer;
}
.select-none {
    -webkit-user-select: none;
            user-select: none;
}
.resize-none {
    resize: none;
}
.resize {
    resize: both;
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-row {
    flex-direction: row;
}
.flex-row-reverse {
    flex-direction: row-reverse;
}
.flex-col {
    flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.items-start {
    align-items: flex-start;
}
.items-end {
    align-items: flex-end;
}
.items-center {
    align-items: center;
}
.items-baseline {
    align-items: baseline;
}
.items-stretch {
    align-items: stretch;
}
.justify-start {
    justify-content: flex-start;
}
.justify-end {
    justify-content: flex-end;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.justify-evenly {
    justify-content: space-evenly;
}
.gap-0 {
    gap: 0px;
}
.gap-1 {
    gap: 0.25rem;
}
.gap-1\\.5 {
    gap: 0.375rem;
}
.gap-2 {
    gap: 0.5rem;
}
.gap-3 {
    gap: 0.75rem;
}
.gap-4 {
    gap: 1rem;
}
.gap-6 {
    gap: 1.5rem;
}
.gap-x-2 {
    column-gap: 0.5rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-auto {
    overflow: auto;
}
.overflow-hidden {
    overflow: hidden;
}
.overflow-y-auto {
    overflow-y: auto;
}
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.whitespace-normal {
    white-space: normal;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.whitespace-pre-wrap {
    white-space: pre-wrap;
}
.text-wrap {
    text-wrap: wrap;
}
.text-nowrap {
    text-wrap: nowrap;
}
.\\!rounded {
    border-radius: 0.25rem !important;
}
.\\!rounded-full {
    border-radius: 9999px !important;
}
.\\!rounded-lg {
    border-radius: 0.5rem !important;
}
.\\!rounded-md {
    border-radius: 0.375rem !important;
}
.rounded {
    border-radius: 0.25rem;
}
.rounded-full {
    border-radius: 9999px;
}
.rounded-lg {
    border-radius: 0.5rem;
}
.rounded-md {
    border-radius: 0.375rem;
}
.rounded-none {
    border-radius: 0px;
}
.rounded-e-md {
    border-start-end-radius: 0.375rem;
    border-end-end-radius: 0.375rem;
}
.rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}
.rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}
.rounded-s-md {
    border-start-start-radius: 0.375rem;
    border-end-start-radius: 0.375rem;
}
.rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
.rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.\\!border {
    border-width: 1px !important;
}
.border {
    border-width: 1px;
}
.border-2 {
    border-width: 2px;
}
.border-cardBorderWidth {
    border-width: var(--card-borderWidth);
}
.border-cardBorderWidthSmall {
    border-width: var(--card-borderWidthSmall);
}
.border-filterCardBorderWidth {
    border-width: var(--filterCard-borderWidth);
}
.border-b {
    border-bottom-width: 1px;
}
.border-b-0 {
    border-bottom-width: 0px;
}
.border-b-2 {
    border-bottom-width: 2px;
}
.border-b-4 {
    border-bottom-width: 4px;
}
.border-l {
    border-left-width: 1px;
}
.border-l-2 {
    border-left-width: 2px;
}
.border-r {
    border-right-width: 1px;
}
.border-t {
    border-top-width: 1px;
}
.border-solid {
    border-style: solid;
}
.border-dashed {
    border-style: dashed;
}
.\\!border-none {
    border-style: none !important;
}
.border-none {
    border-style: none;
}
.\\!border-gray-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.\\!border-vjwDanger {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.border-blue-200 {
    --tw-border-opacity: 1;
    border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
.border-blue-400 {
    --tw-border-opacity: 1;
    border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.border-blue-900 {
    --tw-border-opacity: 1;
    border-color: rgb(30 58 138 / var(--tw-border-opacity));
}
.border-cardBorderColor {
    border-color: var(--card-borderColor);
}
.border-cardBorderColorSmall {
    border-color: var(--card-borderColorSmall);
}
.border-filterCardBorderColor {
    border-color: var(--filterCard-borderColor);
}
.border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-500 {
    --tw-border-opacity: 1;
    border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-red-400 {
    --tw-border-opacity: 1;
    border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-stone-300 {
    --tw-border-opacity: 1;
    border-color: rgb(214 211 209 / var(--tw-border-opacity));
}
.border-transparent {
    border-color: transparent;
}
.border-vjwDanger {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity));
}
.border-vjwPrimary {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.border-white {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-b-vjwPrimary {
    --tw-border-opacity: 1;
    border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-cardBackground {
    background-color: var(--card-backgroundColor);
}
.bg-cardBackgroundSmall {
    background-color: var(--card-backgroundColorSmall);
}
.bg-cardDayChipBackground {
    background-color: var(--card-dayChip-backgroundColor);
}
.bg-cardDayChipBackgroundSmall {
    background-color: var(--card-dayChip-backgroundColorSmall);
}
.bg-cardJobTypeStatusBackground {
    background-color: var(--card-jobTypeStatus-backgroundColor);
}
.bg-cardJobTypeStatusBackgroundSmall {
    background-color: var(--card-jobTypeStatus-backgroundColorSmall);
}
.bg-containerBackground {
    background-color: var(--color-background);
}
.bg-filterCardBackground {
    background-color: var(--filterCard-backgroundColor);
}
.bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-400 {
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-gray-900 {
    --tw-bg-opacity: 1;
    background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.bg-red-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-stone-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(231 229 228 / var(--tw-bg-opacity));
}
.bg-transparent {
    background-color: transparent;
}
.bg-vjwDanger {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-danger) h s l / var(--tw-bg-opacity));
}
.bg-vjwDanger\\/10 {
    background-color: hsl(from var(--color-danger) h s l / 0.1);
}
.bg-vjwDanger\\/20 {
    background-color: hsl(from var(--color-danger) h s l / 0.2);
}
.bg-vjwPrimary {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
}
.bg-vjwSecondary {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}
.bg-vjwSuccess {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-success) h s l / var(--tw-bg-opacity));
}
.bg-vjwSuccess\\/50 {
    background-color: hsl(from var(--color-success) h s l / 0.5);
}
.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
    --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-white {
    --tw-gradient-from: #fff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blue-100 {
    --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
}
.object-contain {
    object-fit: contain;
}
.object-cover {
    object-fit: cover;
}
.\\!p-2 {
    padding: 0.5rem !important;
}
.p-0 {
    padding: 0px;
}
.p-0\\.5 {
    padding: 0.125rem;
}
.p-1 {
    padding: 0.25rem;
}
.p-1\\.5 {
    padding: 0.375rem;
}
.p-2 {
    padding: 0.5rem;
}
.p-3 {
    padding: 0.75rem;
}
.p-4 {
    padding: 1rem;
}
.p-6 {
    padding: 1.5rem;
}
.\\!px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.\\!px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}
.\\!py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
.\\!py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.px-0 {
    padding-left: 0px;
    padding-right: 0px;
}
.px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
.px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}
.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
}
.py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}
.\\!pr-20 {
    padding-right: 5rem !important;
}
.\\!ps-2 {
    padding-inline-start: 0.5rem !important;
}
.pb-0 {
    padding-bottom: 0px;
}
.pb-10 {
    padding-bottom: 2.5rem;
}
.pb-2 {
    padding-bottom: 0.5rem;
}
.pb-20 {
    padding-bottom: 5rem;
}
.pb-4 {
    padding-bottom: 1rem;
}
.pb-6 {
    padding-bottom: 1.5rem;
}
.pl-10 {
    padding-left: 2.5rem;
}
.pl-2 {
    padding-left: 0.5rem;
}
.pl-3 {
    padding-left: 0.75rem;
}
.pl-4 {
    padding-left: 1rem;
}
.pr-1 {
    padding-right: 0.25rem;
}
.pr-4 {
    padding-right: 1rem;
}
.ps-2 {
    padding-inline-start: 0.5rem;
}
.pt-0 {
    padding-top: 0px;
}
.pt-2 {
    padding-top: 0.5rem;
}
.text-left {
    text-align: left;
}
.\\!text-center {
    text-align: center !important;
}
.text-center {
    text-align: center;
}
.text-start {
    text-align: start;
}
.font-fontFamily {
    font-family: var(--fontFamily);
}
.\\!text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}
.text-\\[10px\\] {
    font-size: 10px;
}
.text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}
.text-cardDayChipFontSize {
    font-size: var(--card-dayChip-fontSize);
}
.text-cardDayChipFontSizeSmall {
    font-size: var(--card-dayChip-fontSizeSmall);
}
.text-cardFontSize {
    font-size: var(--card-fontSize);
}
.text-cardFontSizeSmall {
    font-size: var(--card-fontSizeSmall);
}
.text-cardHeadingFontSize {
    font-size: var(--card-heading-fontSize);
}
.text-cardHeadingFontSizeSmall {
    font-size: var(--card-heading-fontSizeSmall);
}
.text-cardJobTypeStatusFontSize {
    font-size: var(--card-jobTypeStatus-fontSize);
}
.text-cardJobTypeStatusFontSizeSmall {
    font-size: var(--card-jobTypeStatus-fontSizeSmall);
}
.text-cardSubHeadingFontSize {
    font-size: var(--card-subHeading-fontSize);
}
.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}
.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
.text-typographyHeadingFontSize {
    font-size: var(--typography-heading-fontSize);
}
.text-typographyLabelsFontSize {
    font-size: var(--typography-labels-fontSize);
}
.text-typographySubheadingFontSize {
    font-size: var(--typography-subHeading-fontSize);
}
.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}
.text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
}
.font-bold {
    font-weight: 700;
}
.font-cardFontWeight {
    font-weight: var(--card-fontWeight);
}
.font-cardFontWeightSmall {
    font-weight: var(--card-fontWeightSmall);
}
.font-cardHeadingFontWeight {
    font-weight: var(--card-heading-fontWeight);
}
.font-cardHeadingFontWeightSmall {
    font-weight: var(--card-heading-fontWeightSmall);
}
.font-cardSubHeadingFontWeight {
    font-weight: var(--card-subHeading-fontWeight);
}
.font-medium {
    font-weight: 500;
}
.font-normal {
    font-weight: 400;
}
.font-semibold {
    font-weight: 600;
}
.font-typographyHeadingFontWeight {
    font-weight: var(--typography-heading-fontWeight);
}
.font-typographyLabelsFontWeight {
    font-weight: var(--typography-labels-fontWeight);
}
.font-typographySubheadingFontWeight {
    font-weight: var(--typography-subHeading-fontWeight);
}
.uppercase {
    text-transform: uppercase;
}
.capitalize {
    text-transform: capitalize;
}
.\\!text-black {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-gray-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-cardDayChipTextColor {
    color: var(--card-dayChip-color);
}
.text-cardDayChipTextColorSmall {
    color: var(--card-dayChip-colorSmall);
}
.text-cardHeadingTextColor {
    color: var(--card-heading-color);
}
.text-cardJobTypeStatusTextColor {
    color: var(--card-jobTypeStatus-color);
}
.text-cardJobTypeStatusTextColorSmall {
    color: var(--card-jobTypeStatus-colorSmall);
}
.text-cardSubHeadingTextColor {
    color: var(--card-subHeading-color);
}
.text-cardTextColor {
    color: var(--card-color);
}
.text-cardTextColorSmall {
    color: var(--card-colorSmall);
}
.text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500 {
    --tw-text-opacity: 1;
    color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-indigo-500 {
    --tw-text-opacity: 1;
    color: rgb(99 102 241 / var(--tw-text-opacity));
}
.text-indigo-700 {
    --tw-text-opacity: 1;
    color: rgb(67 56 202 / var(--tw-text-opacity));
}
.text-red-500 {
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700 {
    --tw-text-opacity: 1;
    color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-typographyHeadingTextColor {
    color: var(--typography-heading-color);
}
.text-typographyLabelsTextColor {
    color: var(--typography-labels-color);
}
.text-typographySubHeadingTextColor {
    color: var(--typography-subHeading-color);
}
.text-vjwDanger {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-danger) h s l / var(--tw-text-opacity));
}
.text-vjwPrimary {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}
.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-opacity-30 {
    --tw-text-opacity: 0.3;
}
.\\!accent-vjwAccent {
    accent-color: hsl(from var(--color-accent) h s l / 1) !important;
}
.opacity-0 {
    opacity: 0;
}
.opacity-25 {
    opacity: 0.25;
}
.opacity-50 {
    opacity: 0.5;
}
.opacity-80 {
    opacity: 0.8;
}
.\\!shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cardBoxShadow {
    --tw-shadow: var(--card-boxShadow);
    --tw-shadow-colored: var(--card-boxShadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cardBoxShadowSmall {
    --tw-shadow: var(--card-boxShadowSmall);
    --tw-shadow-colored: var(--card-boxShadowSmall);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-filterCardBoxShadow {
    --tw-shadow: var(--filterCard-boxShadow);
    --tw-shadow-colored: var(--filterCard-boxShadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.outline {
    outline-style: solid;
}
.ring-1 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-vjwDanger {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-danger) h s l / var(--tw-ring-opacity));
}
.ring-vjwPrimary {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}
.ring-opacity-5 {
    --tw-ring-opacity: 0.05;
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
    --tw-backdrop-blur: blur(4px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
            backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.duration-150 {
    transition-duration: 150ms;
}
.duration-200 {
    transition-duration: 200ms;
}
.duration-300 {
    transition-duration: 300ms;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Custom Scrollbar Styles */
/* Desktop view */
@media (min-width: 899px) {
  ::-webkit-scrollbar {
    width: 8px;
  }
}

/* Mobile view */
@media (max-width: 900px) {
  ::-webkit-scrollbar {
  }
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #acacac;
  border-radius: 10px;
  border: 2px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #acacac;
}

.horizontal-scroll-container {
  overflow-x: auto;
  scrollbar-width: thin;
  scroll-behavior: smooth;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */
}

.scroll-container {
  overflow-y: auto;
  scrollbar-width: thin;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */

  /* Custom scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #acacac;
    border-radius: 10px;
    border: 2px solid transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #acacac;
  }
}

.focus-within\\:border-2:focus-within {
    border-width: 2px;
}

.focus-within\\:border-vjwPrimary:focus-within {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}

.hover\\:\\!border-vjwPrimary:hover {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}

.hover\\:border-black:hover {
    --tw-border-opacity: 1;
    border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.hover\\:border-gray-400:hover {
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity));
}

.hover\\:border-vjwPrimary\\/80:hover {
    border-color: hsl(from var(--color-primary) h s l / 0.8);
}

.hover\\:border-b-blue-500:hover {
    --tw-border-opacity: 1;
    border-bottom-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.hover\\:border-b-vjwPrimary:hover {
    --tw-border-opacity: 1;
    border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}

.hover\\:bg-blue-50:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}

.hover\\:bg-vjwDanger\\/30:hover {
    background-color: hsl(from var(--color-danger) h s l / 0.3);
}

.hover\\:bg-vjwPrimary:hover {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
}

.hover\\:bg-vjwSecondary:hover {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}

.hover\\:text-vjwPrimary:hover {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}

.hover\\:text-vjwSecondary:hover {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-secondary) h s l / var(--tw-text-opacity));
}

.hover\\:underline:hover {
    text-decoration-line: underline;
}

.hover\\:shadow-lg:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:ring-1:hover {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-vjwPrimary:hover {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}

.focus-within\\:hover\\:border-vjwPrimary:hover:focus-within {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}

.focus\\:\\!border-2:focus {
    border-width: 2px !important;
}

.focus\\:\\!border-vjwDanger:focus {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}

.focus\\:\\!border-vjwPrimary:focus {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}

.focus\\:bg-vjwSecondary:focus {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}

.focus\\:text-vjwPrimary:focus {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}

.focus\\:\\!outline-none:focus {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.focus\\:ring:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-vjwPrimary:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}

.active\\:cursor-grabbing:active {
    cursor: grabbing;
}

.disabled\\:\\!cursor-not-allowed:disabled {
    cursor: not-allowed !important;
}

.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
}

.disabled\\:\\!opacity-50:disabled {
    opacity: 0.5 !important;
}

.disabled\\:opacity-50:disabled {
    opacity: 0.5;
}

@media (min-width: 640px) {
    .sm\\:col-span-2 {
        grid-column: span 2 / span 2;
    }
    .sm\\:flex {
        display: flex;
    }
    .sm\\:h-14 {
        height: 3.5rem;
    }
    .sm\\:h-auto {
        height: auto;
    }
    .sm\\:w-14 {
        width: 3.5rem;
    }
    .sm\\:w-48 {
        width: 12rem;
    }
    .sm\\:w-96 {
        width: 24rem;
    }
    .sm\\:w-full {
        width: 100%;
    }
    .sm\\:max-w-sm {
        max-width: 24rem;
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .sm\\:flex-row {
        flex-direction: row;
    }
    .sm\\:flex-nowrap {
        flex-wrap: nowrap;
    }
    .sm\\:p-8 {
        padding: 2rem;
    }
    .sm\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .sm\\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .sm\\:text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem;
    }
    .sm\\:text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
}

@media (min-width: 768px) {
    .md\\:w-1\\/4 {
        width: 25%;
    }
    .md\\:w-3\\/4 {
        width: 75%;
    }
    .md\\:max-w-md {
        max-width: 28rem;
    }
    .md\\:scale-100 {
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }
    .md\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-cols-noOfJobCardsPerRow {
        grid-template-columns: repeat(var(--noOfJobCardsPerRow), minmax(0, 1fr));
    }
    .md\\:flex-row {
        flex-direction: row;
    }
    .md\\:gap-6 {
        gap: 1.5rem;
    }
    .md\\:p-4 {
        padding: 1rem;
    }
    .md\\:p-8 {
        padding: 2rem;
    }
    .md\\:text-2xl {
        font-size: 1.5rem;
        line-height: 2rem;
    }
    .md\\:text-base {
        font-size: 1rem;
        line-height: 1.5rem;
    }
    .md\\:text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
}

@media (min-width: 900px) {
    .vjwMd\\:relative {
        position: relative;
    }
    .vjwMd\\:left-auto {
        left: auto;
    }
    .vjwMd\\:right-4 {
        right: 1rem;
    }
    .vjwMd\\:right-80 {
        right: 20rem;
    }
    .vjwMd\\:z-auto {
        z-index: auto;
    }
    .vjwMd\\:block {
        display: block;
    }
    .vjwMd\\:inline-block {
        display: inline-block;
    }
    .vjwMd\\:hidden {
        display: none;
    }
    .vjwMd\\:h-auto {
        height: auto;
    }
    .vjwMd\\:max-h-\\[90vh\\] {
        max-height: 90vh;
    }
    .vjwMd\\:w-1\\/6 {
        width: 16.666667%;
    }
    .vjwMd\\:w-2\\/5 {
        width: 40%;
    }
    .vjwMd\\:min-w-72 {
        min-width: 18rem;
    }
    .vjwMd\\:max-w-2xl {
        max-width: 42rem;
    }
    .vjwMd\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .vjwMd\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .vjwMd\\:flex-row {
        flex-direction: row;
    }
    .vjwMd\\:justify-center {
        justify-content: center;
    }
    .vjwMd\\:gap-0 {
        gap: 0px;
    }
    .vjwMd\\:gap-4 {
        gap: 1rem;
    }
    .vjwMd\\:rounded-full {
        border-radius: 9999px;
    }
    .vjwMd\\:bg-transparent {
        background-color: transparent;
    }
    .vjwMd\\:bg-vjwPrimary {
        --tw-bg-opacity: 1;
        background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
    }
    .vjwMd\\:p-4 {
        padding: 1rem;
    }
    .vjwMd\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .vjwMd\\:py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .vjwMd\\:text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
    }
    .vjwMd\\:hover\\:bg-vjwPrimary:hover {
        --tw-bg-opacity: 1;
        background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
    }
}

@media (min-width: 1024px) {
    .lg\\:col-span-2 {
        grid-column: span 2 / span 2;
    }
    .lg\\:col-span-4 {
        grid-column: span 4 / span 4;
    }
    .lg\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .lg\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }
    .lg\\:text-3xl {
        font-size: 1.875rem;
        line-height: 2.25rem;
    }
    .lg\\:text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";EAAA,qBAAc;EAAd;;;IAAA,sBAAc;IAAd,SAAc;IAAd,UAAc;IAAd,eAAc,EAAd,kCAAc;IAAd,mBAAc,EAAd,mCAAc;IAAd,qBAAc;EAAA;;EAAd,kCAAc;EAAd;IAAA,gBAAc;IAAd,8BAAc;IAAd,oBAAc;EAAA;;EAAd;IAAA,iBAAc;IAAd,uBAAc;IAAd,6BAAc;EAAA;;EAAd,oCAAc;EAAd;;IAAA,eAAc;IAAd,cAAc;EAAA;;EAAd,yCAAc;EAAd;;;;IAAA,aAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,yBAAc;EAAA;;EAAd,uBAAc;EAAd;;IAAA,gBAAc;EAAA;;EAAd,qBAAc;EAAd;IAAA,wBAAc;IAAd,cAAc;EAAA;;EAAd,sCAAc;EAAd;;;IAAA,qBAAc,EAAd,wCAAc;EAAA;;EAAd,uDAAc;EAAd;;;;;IAAA,6BAAc,EAAd,6BAAc;EAAA;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd;AAAc;AACd;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AACpB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,SAAmB;IAAnB;AAAmB;AAAnB;IAAA,QAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,aAAmB;IAAnB;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA,cAAmB;IAAnB;AAAmB;AAAnB;IAAA,aAAmB;IAAnB;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yDAAmB;IAAnB,qEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,wCAAmB;IAAnB,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;AAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gFAAmB;IAAnB,oGAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB,+QAAmB;YAAnB;AAAmB;AAAnB;IAAA,gKAAmB;IAAnB,wJAAmB;IAAnB,iLAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AA2EnB,4BAA4B;AAC5B,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE;EACA;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;AACpD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;;EAElD,kDAAkD;EAClD;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAzIA;IAAA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,iCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,+EA0IA;IA1IA,mGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,6EA0IA;IA1IA,iGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,iCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,iCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,yCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,8BA0IA;IA1IA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,kBA0IA;QA1IA;IA0IA;IA1IA;QAAA,iBA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;AAAA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,eA0IA;QA1IA,eA0IA;QA1IA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,iBA0IA;QA1IA;IA0IA;IA1IA;QAAA,eA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;AAAA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,kBA0IA;QA1IA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,kBA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;IA1IA;QAAA,oBA0IA;QA1IA;IA0IA;IA1IA;QAAA,kBA0IA;QA1IA;IA0IA;AAAA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  /* Box sizing reset */\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border-width: 0; /* Explicitly reset border width */\n    border-style: solid; /* Ensure consistent border style */\n    border-color: inherit;\n  }\n\n  /* Basic document-level defaults */\n  html {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    font-family: inherit;\n  }\n\n  body {\n    min-height: 100vh;\n    scroll-behavior: smooth;\n    text-rendering: optimizeSpeed;\n  }\n\n  /* Make images easier to work with */\n  img,\n  picture {\n    max-width: 100%;\n    display: block;\n  }\n\n  /* Inherit fonts for inputs and buttons */\n  input,\n  button,\n  textarea,\n  select {\n    font: inherit;\n    /* border: inherit; */\n    border-color: inherit;\n    background-color: inherit;\n  }\n\n  /* Remove list styles */\n  ul,\n  ol {\n    list-style: none;\n  }\n\n  /* Anchor tag reset */\n  a {\n    text-decoration: inherit;\n    color: inherit;\n  }\n\n  /* Only lighten existing div borders */\n  div,\n  input,\n  textarea {\n    border-color: inherit; /* Prevent forcing borders on all divs */\n  }\n\n  /* Lighten borders for divs that already have borders */\n  textarea,\n  input,\n  div[style*='border'] textarea,\n  input,\n  div[class*='border'] {\n    border-color: #ddd !important; /* Lighten existing borders */\n  }\n}\n\n/* Custom Scrollbar Styles */\n/* Desktop view */\n@media (min-width: 899px) {\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n}\n\n/* Mobile view */\n@media (max-width: 900px) {\n  ::-webkit-scrollbar {\n  }\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #acacac;\n  border-radius: 10px;\n  border: 2px solid transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #acacac;\n}\n\n.horizontal-scroll-container {\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scroll-behavior: smooth;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n}\n\n.scroll-container {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n\n  /* Custom scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #acacac;\n    border-radius: 10px;\n    border: 2px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #acacac;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
